const Results = () => {
    const tableStyle = {
      border: "1px solid",
    }

    const titleStyle = {
      paddingTop: "10px",
      paddingBottom: "10px",
      paddingLeft: "5px",
      paddingRight: "5px",
      border: "1px solid",
      "font-weight": "bold"

    }

    const cellStyle = {
      paddingLeft: "20px",
      paddingRight: "20px"
    }

    return (
      <div>
        <h3>Aiempien vuosien tulokset</h3>
        <table rules="rows" style={tableStyle}>
          <tr>
            <td style={titleStyle}>2024</td>
            <td style={cellStyle}><a href="/tulokset/2024/kyvi_24_lopputulokset.htm">Lopputulokset</a></td>
            <td style={cellStyle}><a href="/tulokset/2024/kyvi_24_osuusajat.htm">Osuusajat</a></td>
            <td style={cellStyle}><a href="/tulokset/2024/kyvi_24_valiajat.htm">Väliajat</a></td>
            <td style={cellStyle}><a href="https://www.livelox.com/Events/Show/137503/Kylaviesti-Byakampen-2024">Livelox</a></td>
          </tr>
          <tr>
            <td style={titleStyle}>2023</td>
            <td style={cellStyle}><a href="/tulokset/2023/lopputulokset.htm">Lopputulokset</a></td>
            <td style={cellStyle}><a href="/tulokset/2023/osuusajat.htm">Osuusajat</a></td>
            <td style={cellStyle}><a href="/tulokset/2023/valiajat.htm">Väliajat</a></td>
            <td style={cellStyle}>Livelox</td>
          </tr>
        </table>
      </div>
    )
  }
  
  export default Results